import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { AvantoRestaurantsService } from 'src/app/services/avanto-restaurants.service';
import { Category } from 'src/app/avantoeats-util/models/menu/Category';
import { Product } from 'src/app/avantoeats-util/models/menu/Product';
import { ActivatedRoute } from '@angular/router';
import { ScrollFunctions } from 'src/app/util/ScrollFunctions';
import { AvantoSessionService } from 'src/app/services/avanto-session.service';
import { SessionObject } from 'src/app/avantoeats-util/models/session/SessionObject';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit, OnDestroy {
  private sessionObserver: Subscription;
  private menuSubscription:Subscription;

  menuCategories:Category[];
  isDelivery:boolean;

  //This variable will be used by the modal we open whenever we select a product. 
  //It's initialized with an empty object so we don't get a stupid error on the console.
  selectedProduct:Product = {} as Product;
  
  constructor(private restaurantsService:AvantoRestaurantsService,  private avantoSession:AvantoSessionService, private route: ActivatedRoute) {}

  ngOnInit() {
    this.menuSubscription = this.restaurantsService.subject_selectedRestaurant.subscribe(selectedRestaurant => {
      this.menuCategories = selectedRestaurant.categories;
    });
    this.sessionObserver = this.avantoSession.sessionSubject.subscribe(session => {
      this.isDelivery = session.orderType == SessionObject.ORDER_TYPE_DELIVERY;
    });
  }

  ngOnDestroy(){
    this.menuSubscription.unsubscribe();
    this.sessionObserver.unsubscribe();
  }

  getViewedRestaurantId(): string {
    return this.route.snapshot.params['region'] + "." + this.route.snapshot.params['clientId']
  }

  openProductCustomizationModal(catIndex:number, prodIndex:number, subcategoryIndex?:number){
    const selectedCategory = subcategoryIndex!=null?this.menuCategories[catIndex].subCategories[subcategoryIndex]:this.menuCategories[catIndex];
    this.selectedProduct = selectedCategory.products[prodIndex];
    this.restaurantsService.requestMenuAdd(this.getViewedRestaurantId(), this.selectedProduct);
  }

  scrollToTop(){
    ScrollFunctions.scrollToTop()
  }
}
